import { Component, inject, OnInit } from '@angular/core';

import { AuthenticationService } from 'app/core/authentication';

@Component({
  selector: 'kh-saml-internal-logout',
  template: '',
  standalone: false
})
export class SamlInternalLogoutComponent implements OnInit {
  private readonly authenticationService = inject(AuthenticationService);

  public ngOnInit(): void {
    this.authenticationService.logOut(false);
  }
}
